<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-1">F<span class="smallcaps">IGURES</span></h1>
<p class="fig-list"><a href="#/009_Introduction#fig_1.1">1.1. <span class="pad10">Synoptic problem hypotheses</span></a></p>
<p class="fig-list"><a href="#/009_Introduction#fig_1.2">1.2. <span class="pad10">John and the Synoptics</span></a></p>
<p class="fig-list"><span href="#/010_Chapter01#fig_2.1" title="Link target outside of Sample">2.1. <span class="pad10">Modeling Matthew’s use of a waxed tablet</span></span></p>
<p class="fig-list"><span href="#/010_Chapter01#fig_2.2" title="Link target outside of Sample">2.2. <span class="pad10">Modeling collation, annotation, and composition</span></span></p>
<p class="fig-list"><span href="#/010_Chapter01#fig_2.3" title="Link target outside of Sample">2.3. <span class="pad10">Feeding the Five Thousand according to Codex Fuldensis</span></span></p>
<p class="fig-list"><span href="#/011_Chapter02#fig_3.1" title="Link target outside of Sample">3.1. <span class="pad10">Insulting scribes and Pharisees</span></span></p>
<p class="fig-list"><span href="#/011_Chapter02#fig_3.2" title="Link target outside of Sample">3.2. <span class="pad10">Synopsis of Matt 9:3–4 // Mark 2:6–8 // Luke 5:21–22</span></span></p>
<p class="fig-list"><span href="#/012_Chapter03#fig_4.1" title="Link target outside of Sample">4.1. <span class="pad10">Jesus’s journeys according to Mark</span></span></p>
<p class="fig-list"><span href="#/012_Chapter03#fig_4.2" title="Link target outside of Sample">4.2. <span class="pad10">Jesus’s journeys according to John</span></span></p>
<p class="fig-list"><span href="#/012_Chapter03#fig_4.3" title="Link target outside of Sample">4.3. <span class="pad10">Synopsis of Matt 18:3 and John 3:3</span></span></p>
<p class="fig-list"><span href="#/014_Conclusion#fig_6.1" title="Link target outside of Sample">6.1. <span class="pad10">John and the Synoptics</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006_Figures.vue?4d82cc8a